import { IS_MOBILE, PLATFORM } from "../config.js";
import { loadDevice } from "./plugins.js";
import { deviceTier } from "../utils/deviceTier.js";

function readGpuRenderer(gl) {
  try {
    const ext = gl.getExtension("WEBGL_debug_renderer_info");
    return gl.getParameter(ext ? ext.UNMASKED_RENDERER_WEBGL : gl.RENDERER) || null;
  } catch {
    return null;
  }
}

async function readNativeModel() {
  if (PLATFORM !== "ios" || !loadDevice) return null;
  try {
    const { Device } = await loadDevice();
    return (await Device.getInfo()).model ?? null;
  } catch {
    return null;
  }
}

/** 'high' | 'low' for a phone or tablet, null on desktop or when nothing identifies the device. */
export async function detectDeviceTier(gl) {
  if (!IS_MOBILE) return null;
  return deviceTier({
    gpu: readGpuRenderer(gl),
    model: await readNativeModel(),
    deviceMemory: globalThis.navigator?.deviceMemory,
  });
}
